package fyi.moko.hotpl.domain.model

/**
 * The fixed, single-select emotion palette a visit can carry
 * (docs/archive/EMOTION_TAGS_RESEARCH.md). Spans café and outdoor/park experiences;
 * ordered energetic → comfortable → calm/restorative → self-transcendent/reflective.
 *
 * [id] is the stable string that will be persisted with a visit and in backup JSON —
 * never rename it. [label] is display-only and may be localized later. The color for
 * each emotion lives in the ui layer (Emotion.dotColor), keeping this model framework-free.
 *
 * ── 라벨이 id와 다른 이유 (2026-09-19) ──────────────────────────────
 * id는 회복 어휘(lively/serene/restored/awe/wistful)로 지었지만, 이 앱을 맛집 기록으로
 * 쓰는 리뷰어에게 그 단어들은 식당 리뷰에 나오지 않는 말이라 막혔다. 라벨만 푸디
 * 어휘(Yelp Ambience·Google Atmosphere에 있는 급의 단어)로 바꿨다 —
 * docs/emotion-foodie-vocabulary-2026-09-19.md. 색·순서·회복 축은 그대로다.
 */
enum class Emotion(val id: String, val label: String) {
    LIVELY("lively", "Buzzing"),
    ADVENTUROUS("adventurous", "Adventurous"),
    COZY("cozy", "Cozy"),
    AT_EASE("at_ease", "Laid-back"),
    SERENE("serene", "Quiet"),
    RESTORED("restored", "Recharged"),
    AWE("awe", "Blown away"),
    WISTFUL("wistful", "Nostalgic"),
    ;

    companion object {
        /** Resolves a stored [id] back to an emotion, or null for unknown/absent data. */
        fun fromId(id: String?): Emotion? = id?.let { key -> entries.firstOrNull { it.id == key } }
    }
}
